import { registry } from "@hometoq/backend/registry";
import { createTuyau } from "@tuyau/core/client";
import { apiUrl } from "./env";

const client = createTuyau({
  baseUrl: apiUrl,
  registry,
  headers: {
    Accept: "application/json",
  },
  credentials: "include",
});

export const tuyau = client.api;
export const urlFor = client.urlFor;
